import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerUnifiedEventHeadingText = props => {
  const {
    logicGroup
  } = props;
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const eventName = useMemo(() => {
    return getFilterFamilyObjectName(logicGroup.filterFamily);
  }, [logicGroup.filterFamily, getFilterFamilyObjectName]);
  return /*#__PURE__*/_jsx("strong", {
    children: logicGroup.hasNotCompletedUnifiedEvent === true ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.viewer.relatedGroupHeading.unifiedEventNotCompleted",
      options: {
        eventName
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.viewer.relatedGroupHeading.unifiedEventCompleted",
      options: {
        eventName
      }
    })
  });
};
export default ViewerUnifiedEventHeadingText;